import React from "react";

import { View } from "react-native";
import {
  Empty,
  Error,
  Header,
  Loading,
  CompanyBox,
  AnimatedInfinityList,
} from "components";

import { useCompanies } from "clients/apis";

import { sizes, strings } from "assets/constants";
import { mq } from "utils";
import css from "styles";

export default function Companies() {
  const {
    data,
    error,
    isError,
    refetch,
    isLoading,
    isRefetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useCompanies();

  const _renderItem = (items: []) => {
    return (
      <View style={css.responsiveListContainer}>
        {items.map((company: CompanyT, key: number) => (
          <View key={String(key)} style={css.responsiveBoxContainer}>
            <CompanyBox company={company} />
          </View>
        ))}
      </View>
    );
  };

  const _renderContent = () => {
    if (isLoading) {
      return <Loading style={{ marginTop: mq(20) }} />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    if (data?.pages?.[0]?.data?.data?.length === 0) {
      return (
        <Empty style={{ marginTop: mq(20) }} message={strings.no_company} />
      );
    }

    return (
      <AnimatedInfinityList
        responseData={data}
        onRefresh={refetch}
        renderItemList={_renderItem}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    );
  };

  return (
    <>
      <Header title={strings.companies_db} />
      {_renderContent()}
    </>
  );
}
